<template>
  <div id="app-div" style="overflow-y: hidden">
    <!-- <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="6">
            <label>稿件编号：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCode"
              class="query_input"
            />
          </a-col>
          <a-col :span="6">
            <label>标题：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCnTitle"
              class="query_input"
            />
          </a-col>
          <a-col :span="6">
            <label>作者：</label>
            <a-input
              placeholder="请输入"
              v-model="queryAuthorName"
              class="query_input"
            />
          </a-col>
          <a-button type="primary" class="query_btn" @click="queryInfo">
            查询
          </a-button>
        </a-row>
      </div>
    </div> -->
    <div class="top">
      <a-button type="primary" class="query_btn" @click="selManuscript">
        新增稿件
      </a-button>
      <span style="display: inline-block; margin-left: 20px">{{
        data.length == 0
          ? "本期次暂无建议发表稿件"
          : "本期次共建议发表稿件 " + data.length + " 篇，其中 " + columnTypeNum
      }}</span>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.code"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a href="javascript:void(0);" @click="() => del(record)"> 删除 </a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => up(record)">上移</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => down(record)">下移</a>
          </span>
          <template slot="sort" slot-scope="text, record, index">
            {{ `${index + 1}` }}
          </template>
          <span slot="code" slot-scope="text, record">
            <label @click="manuscriptsInfo(record)" class="view_manu">{{
              record.code
            }}</label>
          </span>
          <span slot="cnTitle" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ record.manuscripts.cnTitle }}</span>
              </template>
              <div class="shenglue">
                <label @click="preview(record)" class="view_manu">{{
                  record.manuscripts.cnTitle
                }}</label>
              </div>
            </a-tooltip>
          </span>
          <span slot="companyName" slot-scope="text, record">
            <span
              :style="{
                color: record.sameCompany ? '#ff4d4f' : 'rgba(0, 0, 0, 0.65)',
              }"
              >{{ text }}</span
            >
          </span>
        </a-table>
      </div>
      <!-- <a-select
        defaultValue="0"
        class="batch_operation"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
        <a-select-option value="2">批量下载</a-select-option>
      </a-select> -->
    </div>
    <a-modal
      title="选择稿件"
      v-model="selVisible"
      :dialog-style="{ top: '20px' }"
      :bodyStyle="{ height: 'calc(100vh - 155px)' }"
      width="90%"
      @ok="handleSelOk"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <Back ref="selBack" :pageType="1" />
    </a-modal>

    <ManuscriptInfo ref="manuscriptInfo" :infoData="manuscript" />
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "sort",
    width: 60,
    scopedSlots: { customRender: "sort" },
  },
  {
    title: "稿件编号",
    dataIndex: "code",
    width: 130,
    scopedSlots: { customRender: "code" },
  },
  {
    title: "标题",
    dataIndex: "manuscripts.cnTitle",
    scopedSlots: { customRender: "cnTitle" },
  },
  {
    title: "作者",
    dataIndex: "manuscripts.authorName",
  },
  {
    title: "单位",
    dataIndex: "manuscripts.companyName",
    scopedSlots: { customRender: "companyName" },
  },
  {
    title: "学科",
    dataIndex: "manuscripts.discipline",
  },
  {
    title: "版本",
    width: 130,
    dataIndex: "sectionInfo",
  },
  {
    title: "栏目",
    dataIndex: "columnName",
  },
  {
    title: "操作",
    width: 140,
    key: "action",
    scopedSlots: { customRender: "operator" },
  },
];

import qs from "qs";
import Back from "./Back.vue";
import ManuscriptInfo from "../../../commomon/ManuscriptInfo.vue";
export default {
  name: "MyManuscripts",
  props: {
    publishRecord: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      destroyOnClose: true,
      manuscript: {},
      data: [],
      columns,
      queryCode: "",
      queryCnTitle: "",
      queryAuthorName: "",
      operateCode: "0",
      table_height: 0,
      bankCard: {},
      selVisible: false,
      columnTypeNum: "",
    };
  },
  created() {
    this.query(this.publishRecord.total);
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  components: {
    Back,
    ManuscriptInfo,
  },
  methods: {
    //预览稿件
    preview(record) {
      var codes = [];
      codes.push(record.code);
      this.axios
        .post("/manuscriptsAddFile/queryByCode", {
          codes: JSON.stringify(codes),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            var addFile = res.data.data;
            if (addFile.length > 0) {
              this.$router.push({
                path: "/edit/preview",
                query: { fileCode: addFile[0].code },
              });
            } else {
              this.utils.messageInfo(this, "error", "稿件不存在！");
            }
          } else {
            this.utils.messageInfo(this, "error", "查询稿件失败！");
          }
        });
    },
    manuscriptsInfo(record) {
      this.manuscript = record.manuscripts;
      this.$refs.manuscriptInfo.show();
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == "1") {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/manuscripts/exportData?codeArr=" +
            selectedRowKeys +
            "&type=2"
        );
      } else if (this.operateCode == "2") {
        //批量下载
        window.open(
          this.serviceAddress +
            "/manuscripts/downLoadBatch?codes=" +
            this.selectedRowKeys.join() +
            "&preview=true&zipName=预览稿件"
        );
      }
      this.operateCode = "0";
    },
    query(planCount) {
      this.axios
        .get("/manuscripts/getManuscriptsSuggestionList", {
          params: {
            planCount: planCount,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.data = res.data.data;

            let columnTypeArr = [];
            this.data.forEach((item) => {
              let f = columnTypeArr.find((c) => c.key == item.columnName);
              if (f) {
                f.value++;
              } else {
                columnTypeArr.push({
                  key: item.columnName,
                  value: 1,
                });
              }
            });
            columnTypeArr.forEach((item, index) => {
              this.columnTypeNum +=
                item.key +
                "：" +
                item.value +
                " 篇" +
                (index < columnTypeArr.length - 1 ? "，" : "。");
            });
          } else {
            this.utils.messageInfo(this, "error", "查询稿件列表失败！");
          }
        });
    },
    queryInfo() {},
    del(record) {
      this.$confirm({
        title: "提示",
        content: "是否确认从建议列表中删除此稿件？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.axios
            .get("/manuscripts/delSuggestion", {
              params: {
                id: record.id,
                time: new Date().getTime(),
              },
              paramsSerializer: function (p) {
                return qs.stringify(p, { arrayFormat: "repeat" });
              },
            })
            .then((res) => {
              if (res.data.code == "OK") {
                this.utils.messageInfo(this, "success", res.data.data);
                this.query(this.publishRecord.total);
              } else {
                this.utils.messageInfo(this, "error", "删除失败");
              }
            });
        },
        onCancel: () => {},
      });
    },
    up(record) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].code == record.code) {
          if (i == 0) {
            this.$message.warning("已经是第一篇");
          } else {
            let temp = this.data[i - 1];
            this.data.splice(i - 1, 1, this.data[i]);
            this.data.splice(i, 1, temp);
            this.$message.success("上移成功");
          }
          break;
        }
      }
    },
    down(record) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id == record.id) {
          if (i == this.data.length - 1) {
            this.$message.warning("已经是最后一篇");
          } else {
            let temp = this.data[i + 1];
            this.data.splice(i + 1, 1, this.data[i]);
            this.data.splice(i, 1, temp);
            this.$message.success("下移成功");
          }
          break;
        }
      }
    },
    selManuscript() {
      this.selVisible = true;
    },
    handleSelOk() {
      this.selVisible = false;
      this.query(this.publishRecord.total);
    },
    confirmList() {
      if (this.data.length == 0) {
        this.utils.messageInfo(this, "error", "请选择稿件");
        return false;
      }
      let result = {
        sectionInfo: this.data[0].sectionInfo,
        selectedColumn: [],
        hasSameCompany: false,
      };
      this.data.forEach((item) => {
        if (item.sameCompany) {
          result.hasSameCompany = true;
        }
        let f = result.selectedColumn.find((c) => c.key == item.columnCode);
        if (f) {
          f.manuscrips.push(item.code);
        } else {
          result.selectedColumn.push({
            key: item.columnCode,
            manuscrips: [item.code],
          });
        }
      });
      return result;
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
</style>
